export const onFinishTrimmed = (values: any, onFinishCallback: (values: any) => void) => {
  Object.entries(values).map(([key, value]) => {
    values[key] = typeof value === 'string' ? value.trim() : value;
  })

  return onFinishCallback(values);
}